import React, { Component } from "react";
import { Table } from 'react-bootstrap';
import "../../assets/css/jquery.dataTables.min.css";
import authService from '../api-authorization/AuthorizeService';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline'
import ReactTable from './ReactTable'
import { CSVLink } from "react-csv";
import { numberformat, parseUtcMs, computeRemainingMs, msToTime } from '../../DateHelper';




class Timmerstandard extends Component {

    constructor(props) {
        super(props);
        console.log(props);

        this.state = {
            time: this.props.time,

        };
        this.timer = null;
    }

    componentDidMount() {

        this.PopulateTimerValue(this.props.time);

    }

    componentDidUpdate() {
        if (this.state.hours == "00" && this.state.minutes == "00" && this.state.seconds == "00") {
            window.clearTimeout(this.timer)
            this.timer = null
        }
    }

    async PopulateTimerValue(truckid) {
        const token = await authService.getAccessToken();
        const response = await fetch('InventoryCode/CheckATimmer?truckid=' + truckid + '&IsStandardorTruck=' + 1 + '&sbnumber=' + '', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const data = await response.json();

        if (data != null) {
            this.start(data.timestamp, data.servertime);
        }

    }

    async timeOver(truckid) {
        const token = await authService.getAccessToken();
        const response = await fetch('InventoryCode/Timeoverforbid?truckid=' + truckid + '&IsStandardorTruck=' + 1 , {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const data = await response.json();
        this.props.goto();
        if (data.data != null) {

        }
        else {

        }

    }




    start(endTimestamp, serverTime) {

        if (!this.timer) {
            this.endEpoch = parseUtcMs(endTimestamp);
            var serverEpoch = parseUtcMs(serverTime);
            this.offset = serverEpoch - Date.now();

            this.timer = window.setInterval(() => this.run(), 10);

        }
    }

    run() {

        const correctedNow = Date.now() + this.offset;
        const remaining = computeRemainingMs(this.endEpoch, correctedNow);





        if (remaining === 0) {
            window.clearTimeout(this.timer);
            this.timer = null;
        }

        this.setState(msToTime(remaining));
    }


    render() {

        const timeOver = (val) => {
            let component = '';

            this.timeOver(val);

            return component;
        }
        //]
        console.log(this.state);

        if (this.state.hours == "00" && this.state.minutes == "00" && this.state.seconds == "00") {
            window.clearTimeout(this.timer)
            this.timer = null

            return (

                <div>
                    {timeOver(this.props.time)}

                </div>
            );
        }
        else {
            return (
                <div>

                    {

                        this.state.hours
                    }: {
                        this.state.minutes
                    }: {
                        this.state.seconds
                    }




                </div>
            );
        }
    }

}

export default Timmerstandard;
